import { CircularProgress } from '@mui/material'

export default function PendingBadge({ testId }) {
    return (
        <CircularProgress
            size={16}
            color="info"
            data-testid={testId}
            aria-label="ממתין לשמירה"
        />
    )
}
